import React from "react";
import classnames from "classnames";

import {
    setActions,
    setIsActionsClicked,
} from "@pages/Peripherals/Monetics/store";
import { CustomCardFooter } from "@components/Common/CustomCardStyled";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

import { useMoneticsForm } from "../MoneticsFormContext";

/** Card footer: Cancel + Validate actions. */
export function MoneticFormFooter() {
    const { form, props } = useMoneticsForm();
    const { t, isActionsClicked, setIsAutoFill, handleValidate } = form;
    const {
        isEdited,
        isConsult,
        isAddMoneticsClicked,
        setIsAddMoneticsClicked,
        setEditedData,
        setInputIp,
        setIsConsult,
        setIsEdited,
    } = props;

    const cancelForm = () => {
        setIsAutoFill(false);
        setIsAddMoneticsClicked(!isAddMoneticsClicked);
        setEditedData([]);
        setInputIp(false);
        setIsConsult(false);
        setIsEdited(false);
    };

    return (
        <CustomCardFooter className="pt-1 pb-2 ">
            <CustomSecondaryColorButton
                outline
                rounded
                className="mr-2 mnt_btn_cancel cmn_btn_cancel"
                data-testid="monetics-cancel-btn"
                variant="light"
                onClick={() => {
                    if (isEdited) {
                        setIsActionsClicked(!isActionsClicked);
                        setActions(cancelForm);
                    } else {
                        cancelForm();
                    }
                }}
            >
                <span> {t("Cancel")}</span>
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                rounded
                className={classnames(
                    "mr-2 mnt_btn_validate cmn_btn_validate",
                    {
                        "not-allowed-icon__clz": isConsult,
                    }
                )}
                data-testid="monetics-validate-btn"
                variant="primary"
                onClick={handleValidate}
            >
                {t("Validate")}
            </CustomMainColorButton>
        </CustomCardFooter>
    );
}
